import React, { type PropsWithChildren } from 'react';

import { useOptions } from '../../controllers/options-provider';
import { useLocalSideNavUserData } from '../../controllers/user-state/persistence/use-local-side-nav-user-data';
import { StoreProviders } from '../../controllers/user-state/store-providers';

export function LocalStore({ children }: PropsWithChildren) {
	const { app } = useOptions();

	// This is user data for the menu and the sidebar
	const userStoreProps = useLocalSideNavUserData({ app });

	return <StoreProviders {...userStoreProps}>{children}</StoreProviders>;
}
